import React from 'react';
import { getBillingFormattedDate, getFormattedDate, parseToDate } from '../../../utils/date';
import disengagedDictionary from './disengagedDictionary';
const getMembershipTimestamp = (title, timestamp) => {
    if (!timestamp) {
        return 'N/A';
    }
    if (title === 'activated' || title === 'discharged' || title === 'cancelled') {
        return getBillingFormattedDate(timestamp, 'MMM d, yyyy');
    }
    return getFormattedDate(parseToDate(timestamp), 'MMM d, yyyy');
};
const getMembershipEventTitle = (title) => {
    switch (title) {
        case 'vacation_started':
        case 'acknowledged':
            return 'Away from home start';
        case 'vacation_cancelled':
        case 'vacation_ended':
            return 'Away from home end';
        case 'activated':
            return 'Activated';
        case 'disengagement':
            return 'Disengaged';
        case 're_engagement':
            return 'Re-engaged';
        case 'monthly_call_reminder':
            return 'Monthly call reminder sent';
        case 'cancelled':
            return 'Discharge finalized';
        case 'discharged':
            return 'Discharged';
        case 'readmitted':
            return 'Re-admitted';
        case 'transfer':
            return 'Transferred';
        case 'reactivation':
            return 'Reactivated';
        case 'readmission':
            return 'Re-admitted';
        default:
            return title;
    }
};
const processMembershipLog = (log) => {
    const output = [];
    if (!log.timestamp) {
        return output;
    }
    if (log.event === 'undefined') {
        return output;
    }
    if (log.event === 'vacation_cancelled') {
        if (log.user_end_datetime) {
            output.push({
                title: 'Away from home end',
                timestamp: getFormattedDate(parseToDate(log.user_end_datetime), 'MMM d, yyyy')
            });
        }
        if (log.user_start_datetime) {
            output.push({
                title: 'Away from home start',
                timestamp: getFormattedDate(parseToDate(log.user_start_datetime), 'MMM d, yyyy')
            });
        }
        return output;
    }
    if (log.event === 'discharged' && log.readmitted_at) {
        output.push({
            title: 'Re-admitted',
            timestamp: getFormattedDate(parseToDate(log.readmitted_at), 'MMM d, yyyy')
        });
    }
    output.push({
        title: getMembershipEventTitle(log.event),
        timestamp: getMembershipTimestamp(log.event, log.timestamp),
        description: log.disengaged_reason
            ? disengagedDictionary[log.disengaged_reason]?.label
            : log.event === 'vacation_started' && log.user_end_datetime
                ? `End scheduled for ${getFormattedDate(parseToDate(log.user_end_datetime), 'MMM d, yyyy')}`
                : log.discharged_reason
                    ? log.discharged_reason
                    : undefined
    });
    return output;
};
const sortMembershipLogs = (logs) => {
    return logs.sort((a, b) => {
        if (!a.timestamp || !b.timestamp)
            return 0;
        const dateA = new Date(a.timestamp).getTime();
        const dateB = new Date(b.timestamp).getTime();
        return dateB - dateA;
    });
};
export const usePreparedMembershipLogs = (membershipLogs) => {
    return React.useMemo(() => {
        if (!membershipLogs) {
            return [];
        }
        const output = [];
        for (const log of membershipLogs) {
            if (log.event !== 'readmitted') {
                const processedLogs = processMembershipLog(log);
                output.push(...processedLogs);
            }
        }
        return sortMembershipLogs(output);
    }, [membershipLogs]);
};
